'use strict';

var _ = require('lodash');

function PageController ($scope, sbNavDrawerService) {

  var DEFAULTS = {
    id: '',
    index: null,
    visible: false,
    view: '',
  };

  var vm = this;
  var pageManager = null;
  var viewManager = null;

  _.defaults(vm, DEFAULTS);

  vm.init = function () {
    pageManager = sbNavDrawerService.getPageManager();
    viewManager = sbNavDrawerService.getViewManager(vm.id);
    pageManager.register(vm.id, vm.index);
  };

  $scope.$on('$destroy', function() {
    pageManager.removePage(vm.id);
    viewManager.removeAll();
  });

  vm.getAttr = function (attr) {
    return function () {
      return this[attr];
    }.bind(this);
  }.bind(this);

  vm.getId = function () {
    return vm.id;
  };

  vm.getPosClass = function (otherPage) {
    var pos = '';
    var index = pageManager.getPageIndex(otherPage);

    vm.index = pageManager.getPageIndex(vm.id);

    if (index > vm.index) {
      pos = 'above';
    } else if (index < vm.index) {
      pos = 'below';
    }

    return pos;
  };

  vm.getDefaultView = function() {
    return viewManager.getDefault();
  };

  vm.setActiveView = function (viewId) {
    vm.view = viewId;
    viewManager.setActive(viewId);
  };
}

module.exports = PageController;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/page/PageController.js